import React, { useState } from 'react';
import { formatClockTime } from '../../lib/businessHours';
import { D2_INPUT } from '../settings/signatures/d2Fields';

export function TimeField({ label, value, onChange, onBlur, className = '' }) {
    const [editing, setEditing] = useState(false);
    const shown = formatClockTime(value);
    return (
        <span className="relative inline-flex" data-time-field="true">
            <input
                type="time"
                aria-label={label}
                value={value}
                className={`${D2_INPUT} ${className || 'w-[8.5rem]'} ${!editing && shown ? 'ia-time-masked' : ''}`}
                onFocus={() => setEditing(true)}
                onChange={(event) => onChange(event.target.value)}
                onBlur={() => { setEditing(false); onBlur?.(); }}
            />
            {!editing && shown && (
                <span aria-hidden="true" data-time-label="true" className="pointer-events-none absolute inset-y-0 left-[11px] flex items-center text-sm font-semibold text-white">
                    {shown}
                </span>
            )}
        </span>
    );
}
